import { render, staticRenderFns } from "./LeaveCreateEditModal.vue?vue&type=template&id=1f0f28aa"
import script from "./LeaveCreateEditModal.vue?vue&type=script&lang=js"
export * from "./LeaveCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports